import React from 'react';
import { observer, useLocalStore } from 'mobx-react';

import { RequirementEntity } from 'Models/Entities';

import { Select, OnChangeValue } from 'Views/Components/Select/Select';

export type ComboboxAfterSave = (
	newValue: OnChangeValue<unknown, false>,
) => void;

/**
 * List program structure's components on the step 1 page of the study plan wizard
 *
 * Component's options are ordered by name in alphabetical order by default
 */
const ComponentDropdown = observer((props: {
	component: RequirementEntity,
	errors: Record<string, string>,
	onAfterSelectRequirement: ComboboxAfterSave,
	initialSelectedRequirementId: string | undefined,
}) => {
	const {
		component,
		errors,
		onAfterSelectRequirement,
		initialSelectedRequirementId,
	} = props;

	const componentComboboxModel = useLocalStore(
		() => ({ selectedTopLevelRequirementId: initialSelectedRequirementId }),
	);

	const selectedRequirement = component
		.requirements
		.find(requirement => requirement.id === componentComboboxModel.selectedTopLevelRequirementId);

	const options = component.requirements
		.map(requirement => ({
			value: requirement.id,
			display: requirement.displayName,
		}))
		.sort((a, b) => a.display.localeCompare(b.display));

	const displayedErrors = !componentComboboxModel.selectedTopLevelRequirementId && errors.component?.length
		? errors.component
		: undefined;

	return (
		<>
			<Select
				label={component.displayName}
				placeholder={`Select ${component.displayName}`}
				model={componentComboboxModel}
				modelProperty="selectedTopLevelRequirementId"
				options={options}
				onAfterChange={onAfterSelectRequirement}
				errors={displayedErrors}
				inputProps={{
					'aria-label': component.displayName,
					id: `${component.id}-select`,
				}}
			/>
			{selectedRequirement?.description ? (
				<p className="component-description">
					{selectedRequirement.description}
				</p>
			) : null}
		</>
	);
});

export default ComponentDropdown;
